exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;800&display=swap);", ""]);
// Module
exports.push([module.id, "\n", ""]);
